import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import Coach from "./Coach";
import Academy from "./Academy";

const { TabPane } = Tabs;

function CoachAcademyIndex() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab key based on current URL pathway, default to 'coach'
  const activeKey = location.pathname.includes("/admin/academy-manager")
    ? "academy"
    : "coach";

  const handleTabChange = (key) => {
    if (key === "academy") {
      navigate("/admin/academy-manager");
    } else {
      navigate("/admin/coach-manager");
    }
  };

  return (
    <div style={{ padding: "24px" }}>
      <Tabs activeKey={activeKey} onChange={handleTabChange}>
        <TabPane tab="Coach Manager" key="coach">
          <Coach />
        </TabPane>
        <TabPane tab="Academy Manager" key="academy">
          <Academy />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default CoachAcademyIndex;
